export type Heading = { id: string; level: number; text: string };

export const TOC_TITLE = 'On this page';

export const describeCount = (count: number, noun: string) => {
  if (count === 1) {
    return `1 ${noun}`;
  }
  return `${count} ${noun}s`;
};
